import React, { useState } from 'react';
import axios from 'axios';
import '../App.css';
import { Link } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const GeminiPromptGenerator = () => {
  const [tokenCount, setTokenCount] = useState(10);
  const [iterations, setIterations] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleGeneratePrompts = async () => {
    setLoading(true);
    setError(null);

    try {
      for (let i = 0; i < iterations; i++) {
        await axios.post(`${API_BASE_URL}/api/generate?token_count=${tokenCount}`, null);
      }
    } catch (err) {
      setError(err.message);
      console.error('Error generating prompts:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="header">
        <h1>Gemini Prompt Generator</h1>
        <Link to="/logs" className="logs-link">View Logs</Link>
        <Link to="/metrics" className="logs-link">View Metrics</Link>
      </header>
      <div className="prompt-generator-container">
        <div className="prompt-generator-controls">
          <select value={tokenCount} onChange={(e) => setTokenCount(Number(e.target.value))}>
            <option value={10}>10 Tokens</option>
            <option value={100}>100 Tokens</option>
            <option value={1000}>1000 Tokens</option>
            <option value={10000}>10000 Tokens</option>
          </select>
          <select value={iterations} onChange={(e) => setIterations(Number(e.target.value))}>
            <option value={10}>10 Iterations</option>
            <option value={100}>100 Iterations</option>
            <option value={1000}>1000 Iterations</option>
          </select>
          <button onClick={handleGeneratePrompts} disabled={loading}>
            {loading ? 'Generating...' : 'Generate Prompts'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeminiPromptGenerator;
